export default {
  // Title
  transactionOverview: "Transaction Overview",
  assetDistribution: "Asset Distribution",

  // Tooltip
  unitTooltip: "Unit: Selected currency on the right",

  // Currency selection
  selectCurrency: "Select Currency",

  // Statistics labels
  addressBalance: "Address Balance",
  cumulativeInflowOutflow: "Cumulative Inflow & Outflow Amount",
  averageInflowOutflow: "Average Inflow & Outflow Amount",
  inflowOutflowCount: "Inflow & Outflow Count",
  inflowOutflowOpponents: "Inflow & Outflow Opponents",

  // Empty state
  noData: "No data",

  // Chart series name
  assetDistributionSeries: "Asset Distribution",
};
